import * as React from 'react';
import ItemTypes from './ItemTypes';
import { DropdownButton, MenuItem } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import ImpersonateButton from '../../ImpersonateButton';

interface INodeActionButtonsProps {
    item: any;
    onClick: (item: any, type: string) => void;
    onDelete: (item: any) => void;
    onRestore: (item: any) => void;
    canCreate: boolean;
    canDelete: boolean;
    canRestore: boolean;
    showLogs: (id: number) => void;
}

const NodeActionButtons = (props: INodeActionButtonsProps) => {
    let type: any = ItemTypes.Chain;
    if (props.item.type === ItemTypes.FirmGroup.name) {
        type = ItemTypes.FirmGroup;
    } else if (props.item.type === ItemTypes.Firm.name) {
        type = ItemTypes.Firm;
    } else if (props.item.type === ItemTypes.Agent.name) {
        type = ItemTypes.Agent;
    }

    let availableTypes = Array.isArray(props.item.availableTypes) ? props.item.availableTypes : [];
    let hasChildren = props.item.children && props.item.children.length > 0;

    return (
        <DropdownButton
            bsSize="xsmall"
            bsStyle="default"
            noCaret
            title={Translate('broker-tree/edit')}
            id={'dropdown' + props.item.id}
        >
            {props.canCreate &&
                availableTypes.map((type: any) => {
                    return getCreateAction(props.onClick, props.item, type.name);
                })}

            {type === ItemTypes.Agent && (
                <ImpersonateButton userId={props.item.brokerEntityId} type="MenuItem" />
            )}

            <MenuItem
                onSelect={() => {
                    props.showLogs(props.item.id);
                }}
            >
                <i className="material-icons">list</i> {Translate('broker-tree/node/actions/logs')}
            </MenuItem>

            {props.canCreate && props.canDelete && <MenuItem divider />}

            {props.canDelete && !props.item.isRemoved && (
                <MenuItem
                    onSelect={() => {
                        props.onDelete(props.item);
                    }}
                >
                    <i className="material-icons delete">delete_forever</i>{' '}
                    {Translate('broker-tree/delete')}
                </MenuItem>
            )}

            {props.canRestore && props.item.isRemoved && (
                <MenuItem
                    onSelect={() => {
                        props.onRestore(props.item);
                    }}
                >
                    <i className="material-icons">restore</i>{' '}
                    {Translate('broker-tree/node/actions/restore')}
                </MenuItem>
            )}
        </DropdownButton>
    );
};

function getCreateAction(onClick: (item: any, type: string) => void, item: any, type: any) {
    switch (type) {
        case ItemTypes.Chain.name:
            return (
                <MenuItem
                    key={item.id + ItemTypes.Chain.name}
                    onSelect={() => {
                        onClick(item, ItemTypes.Chain.name);
                    }}
                >
                    <i className="material-icons add">{ItemTypes.Chain.addIcon}</i>{' '}
                    {Translate('broker-tree/new-chain')}
                </MenuItem>
            );
        case ItemTypes.FirmGroup.name:
            return (
                <MenuItem
                    key={item.id + ItemTypes.FirmGroup.name}
                    onSelect={() => {
                        onClick(item, ItemTypes.FirmGroup.name);
                    }}
                >
                    <i className="material-icons add">{ItemTypes.FirmGroup.addIcon}</i>{' '}
                    {Translate('broker-tree/new-firm-group')}
                </MenuItem>
            );
        case ItemTypes.Firm.name:
            return (
                <MenuItem
                    key={item.id + ItemTypes.Firm.name}
                    onSelect={() => {
                        onClick(item, ItemTypes.Firm.name);
                    }}
                >
                    <i className="material-icons add">{ItemTypes.Firm.addIcon}</i>{' '}
                    {Translate('broker-tree/new-firm')}
                </MenuItem>
            );
        case ItemTypes.Agent.name:
            return (
                <MenuItem
                    key={item.id + ItemTypes.Agent.name}
                    onSelect={() => {
                        onClick(item, ItemTypes.Agent.name);
                    }}
                >
                    <i className="material-icons add">{ItemTypes.Agent.addIcon}</i>{' '}
                    {Translate('broker-tree/new-agent')}
                </MenuItem>
            );
        default:
            return null;
    }
}

export default NodeActionButtons;
